import { render, staticRenderFns } from "./GrantAdd.vue?vue&type=template&id=3d9a2ec2&"
import script from "./GrantAdd.vue?vue&type=script&lang=js&"
export * from "./GrantAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports